import { configureStore } from "@reduxjs/toolkit";
// import { locationReducer } from "../components/settings/features";
import {
  rememeberMeReducer,
  signinReducer,
} from "../authentication/signin/features/signinSlice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { forgotPasswordReducer } from "../authentication/forgot-password/features/forgotPassword-slice"

export default configureStore({
  reducer: {
    // settings: [],
  },
});
export const store = configureStore({
  reducer: { signin: signinReducer, rememberMe: rememeberMeReducer, forgotPassword:forgotPasswordReducer},
});
// export const store = [];
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
